import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface Address {

}

interface AddresssState {
    data: Address[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

// Diet Mapping Code
export const fetchAddress = createAsyncThunk<Address[], void, { rejectValue: string }>(
    'Address/fetchAddress',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Address[] }>('/get_all_address', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createAddress = createAsyncThunk<Address, any, { rejectValue: string }>(
    'Address/createAddress',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: Address }>('create_address', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateAddress = createAsyncThunk<Address, any, { rejectValue: string }>(
    'Address/updateAddress',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Address }>('update_address', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const AddressSlice = createSlice({
    name: 'Address',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as AddresssState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchAddress.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAddress.fulfilled, (state, action: PayloadAction<Address[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAddress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createAddress.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAddress.fulfilled, (state, action: PayloadAction<Address>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createAddress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateAddress.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAddress.fulfilled, (state, action: PayloadAction<Address>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateAddress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
           
    },
});

export default AddressSlice.reducer;